module.exports = __webpack_public_path__ + "static/media/29DUNON14.127f1d37.jpg";